import type { LegacyDashboardSga, LegacyDashboardSgaProduct } from '../models/LegacyDashboardClient';

function normalizeSgaProduct(value: unknown): LegacyDashboardSgaProduct | null {
  if (!value || typeof value !== 'object') return null;
  const row = value as Record<string, unknown>;
  if (typeof row.id !== 'number' || typeof row.name !== 'string') return null;

  return {
    id: row.id,
    name: row.name,
    code: typeof row.code === 'string' ? row.code : '',
    status: typeof row.status === 'string' ? row.status : '',
    stock_available: Number(row.stock_available) || 0,
    stock_reserved: Number(row.stock_reserved) || 0,
    stock_total: Number(row.stock_total) || 0,
  };
}

export function normalizeLegacyDashboardSga(value: unknown): LegacyDashboardSga | null {
  if (!value || typeof value !== 'object') return null;
  const row = value as Record<string, unknown>;
  const products = Array.isArray(row.products)
    ? row.products.map(normalizeSgaProduct).filter((product): product is LegacyDashboardSgaProduct => product !== null)
    : [];

  return {
    products_count: Number(row.products_count) || products.length,
    products_with_stock_count: Number(row.products_with_stock_count) || 0,
    total_stock_available: Number(row.total_stock_available) || 0,
    total_stock_reserved: Number(row.total_stock_reserved) || 0,
    total_stock: Number(row.total_stock) || 0,
    products,
  };
}
